import { render, staticRenderFns } from "./DvoranaDetails.vue?vue&type=template&id=745af6f2&scoped=true&"
import script from "./DvoranaDetails.vue?vue&type=script&lang=js&"
export * from "./DvoranaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745af6f2",
  null
  
)

export default component.exports